import { ReactElement } from "react";

import { ButtonThemeProps } from "hardcover-ui/theme/components/button";

import UserJoinButtonActive from "./UserJoinButtonActive";

export default function UserJoinButton({
  children,
  variant = "tertiary",
  size = "md",
  tab = "Login",
}: {
  children: ReactElement;
  variant?: ButtonThemeProps["variant"];
  size?: ButtonThemeProps["size"];
  tab: "Join" | "Login";
}) {
  return (
    <UserJoinButtonActive variant={variant} size={size} tab={tab}>
      {children}
    </UserJoinButtonActive>
  );
}
